module.exports = __webpack_public_path__ + "img/Watney2.1fc28891.svg";